export var getSubmenuPointing = function getSubmenuPointing(currentIndex, navigationLength, hasFinalCTA) {
  var actualNavigationLength = hasFinalCTA ? navigationLength + 1 : navigationLength;
  return currentIndex + 1 === actualNavigationLength ? 'top right' : 'top left';
};